module.exports = __webpack_public_path__ + "static/img/10012 (5).3a33833.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10012 (5).webp
// module id = ijSX
// module chunks = 14